// Server clock skew tracking.
//
// The BE stamps every response with `X-Server-Time` (RFC 3339 UTC). We diff
// that against the browser clock right when the response is parsed and cache
// the offset in module state. Consumers who care about "now" for SLA math
// (badge state, countdown) call `serverNow()` instead of `Date.now()` so a
// user with a skewed system clock still sees the correct overdue state.
//
// Offset drifts naturally over long sessions; we refresh it on every response
// so it stays fresh without needing an explicit ping endpoint.

const SERVER_TIME_HEADER = 'x-server-time'

let offsetMs = 0

export function recordServerTime(headerValue: string | undefined | null): void {
    if (!headerValue) return
    const serverMs = Date.parse(headerValue)
    if (Number.isNaN(serverMs)) return
    offsetMs = serverMs - Date.now()
}

export function serverNow(): number {
    return Date.now() + offsetMs
}

export function getServerTimeOffsetMs(): number {
    return offsetMs
}

export const SERVER_TIME_HEADER_NAME = SERVER_TIME_HEADER

// Test hook — reset offset between tests.
export function __resetServerTimeOffsetForTest(): void {
    offsetMs = 0
}
